// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3si2U","title":"ClientCherryInfo_title__3Lem3","itemText":"ClientCherryInfo_itemText__28dmm"};